module.exports = __webpack_public_path__ + "img/asq-architecture-diagram.6a4801d1.png";